import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Icon, Stars } from './Icons'
import { ImgPlaceholder } from './UI'

// ── Destination Card ──────────────────────────────────────────────────
export function DestCard({ name, nights, from, rating, tag, flag, city, country, image, onClick }) {
  const displayName = name || city
  return (
    <div className="dest-card" onClick={onClick} style={{ cursor: 'pointer' }}>
      <ImgPlaceholder height={136} label={displayName} flag={flag} tag={tag} image={image} />
      <div style={{ padding: '15px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '7px',
          }}
        >
          <div>
            <div style={{ fontSize: '15px', fontWeight: 700, color: '#0d1117' }}>{displayName}</div>
            {country && <div style={{ fontSize: '11px', color: '#6b7a8f' }}>{country}</div>}
            {nights && <div style={{ fontSize: '11px', color: '#6b7a8f' }}>{nights}</div>}
          </div>
          {rating && <Stars rating={rating} />}
        </div>

        {from ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: '10px',
            }}
          >
            <div>
              <span style={{ fontSize: '10px', color: '#6b7a8f' }}>from </span>
              <span style={{ fontSize: '18px', fontWeight: 800, color: '#0d1117' }}>{from}</span>
            </div>
            <button
              style={{
                padding: '8px 14px',
                background: 'var(--brand)',
                border: 'none',
                borderRadius: '7px',
                fontSize: '11px',
                fontWeight: 700,
                color: '#fff',
                cursor: 'pointer',
              }}
            >
              View
            </button>
          </div>
        ) : (
          <button
            style={{
              width: '100%',
              marginTop: '10px',
              padding: '9px',
              background: '#f8fafc',
              border: '1.5px solid #e2e8f0',
              borderRadius: '7px',
              fontSize: '11px',
              fontWeight: 700,
              color: '#3d4a5c',
              cursor: 'pointer',
            }}
          >
            Explore City →
          </button>
        )}
      </div>
    </div>
  )
}

// ── Package Card ──────────────────────────────────────────────────────
export function PackageCard({ pkg, travellers }) {
  const navigate = useNavigate()
  const total = travellers * pkg.price
  const isGroup = travellers > 1

  return (
    <div
      className="hover-card"
      onClick={() => navigate(`/package/${pkg.name}`)}
      style={{
        background: '#fff',
        border: '1.5px solid #e2e8f0',
        borderRadius: '12px',
        overflow: 'hidden',
        cursor: 'pointer',
      }}
    >
      {/* Image area */}
      <ImgPlaceholder height={146} tag={pkg.tag} image={pkg.image} />

      <div style={{ padding: '17px' }}>
        <div
          style={{
            fontSize: '9px',
            fontWeight: 700,
            letterSpacing: '1.5px',
            color: 'var(--brand)',
            marginBottom: '5px',
            textTransform: 'uppercase',
          }}
        >
          {pkg.brand}
        </div>
        <h3 style={{ fontSize: '16px', fontWeight: 700, color: '#0d1117', margin: '0 0 8px' }}>
          {pkg.name}
        </h3>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
          <Stars rating={pkg.rating} />
          <span style={{ color: '#6b7a8f', fontSize: '11px' }}>({pkg.reviews})</span>
        </div>
        <div
          style={{
            fontSize: '12px',
            color: '#6b7a8f',
            marginBottom: '14px',
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
          }}
        >
          <Icon name="moon" size={12} color="#6b7a8f" />
          <span>
            {pkg.nights}N / {pkg.nights + 1}D
          </span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
          <div>
            <div style={{ fontSize: '10px', color: '#6b7a8f' }}>
              {isGroup ? `Total for ${travellers}` : 'Per person'}
            </div>
            <div style={{ fontSize: '23px', fontWeight: 800, color: '#0d1117' }}>
              ₹{total.toLocaleString('en-IN')}
            </div>
          </div>
          <button
            style={{
              padding: '10px 20px',
              background: 'var(--brand)',
              border: 'none',
              borderRadius: '8px',
              fontSize: '12px',
              fontWeight: 700,
              color: '#fff',
              cursor: 'pointer',
            }}
            onClick={(e) => {
              e.stopPropagation()
              navigate(`/package/${pkg.name}`)
            }}
          >
            Book Now
          </button>
        </div>
      </div>
    </div>
  )
}

// ── Brand Universe Card (dark) ────────────────────────────────────────
export function BrandCardDark({ brand, onClick }) {
  const [hovered, setHovered] = useState(false)
  return (
    <div
      onClick={() => onClick && onClick(brand.page)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? 'rgba(2,2,191,0.06)' : '#1c2230',
        borderRadius: '11px',
        padding: '20px 17px',
        border: `1.5px solid ${hovered ? 'var(--brand)' : 'rgba(255,255,255,0.07)'}`,
        cursor: 'pointer',
        transition: 'all 0.2s',
      }}
    >
      <div
        style={{
          width: '40px',
          height: '40px',
          background: `${brand.color}20`,
          borderRadius: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '12px',
        }}
      >
        <Icon name={brand.icon} size={18} color={hovered ? 'var(--secondary)' : brand.color} />
      </div>
      <div
        style={{
          fontSize: '13px',
          fontWeight: 700,
          color: '#fff',
          marginBottom: '4px',
          lineHeight: 1.3,
        }}
      >
        {brand.label}
      </div>
      <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.4)' }}>{brand.sub}</div>
    </div>
  )
}

// ── Brand Universe Card (light — for Experiences page) ────────────────
export function BrandCardLight({ brand, onClick }) {
  const [hovered, setHovered] = useState(false)
  return (
    <div
      onClick={() => onClick && onClick(brand.page)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? 'var(--brand-lt)' : '#f8fafc',
        borderRadius: '12px',
        padding: '20px',
        border: `1.5px solid ${hovered ? 'var(--brand)' : '#e2e8f0'}`,
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
        cursor: 'pointer',
        transition: 'all 0.2s',
      }}
    >
      <div
        style={{
          width: '44px',
          height: '44px',
          background: `${brand.color}18`,
          borderRadius: '11px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Icon name={brand.icon} size={20} color={hovered ? 'var(--secondary)' : brand.color} />
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: '14px', fontWeight: 700, color: '#0d1117' }}>{brand.label}</div>
        <div style={{ fontSize: '12px', color: '#6b7a8f' }}>{brand.sub}</div>
      </div>
      <Icon name="arrowRight" size={14} color="#6b7a8f" />
    </div>
  )
}
